import { render } from "./Footer.vue?vue&type=template&id=0e081963&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=0e081963&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0e081963"

export default script